import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { setSchedaCoopSocialiSociVolontariListeners } from './scheda-coop-sociali-soci-volontari.listeners';
import { setSchedaCoopSocialiCategoriaSettoreListeners } from './scheda-coop-sociali-categoria-settore.listeners';
import { setSchedaCoopSocialiLavoratoriMiscListeners } from './scheda-coop-sociali-lavoratori-misc.listeners';

export class SchedaCoopSocialiFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setSchedaCoopSocialiSociVolontariListeners(this.form, this.store);
        setSchedaCoopSocialiCategoriaSettoreListeners(this.form, this.store);
        setSchedaCoopSocialiLavoratoriMiscListeners(this.form, this.store);
    }
}
